/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Globe({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#Globe_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M15.6 8A7.6 7.6 0 1 1 .4 8a7.6 7.6 0 0 1 15.2 0ZM7.254 1.977c.283-.28.535-.377.746-.377.211 0 .463.097.746.377.286.282.571.72.824 1.31.45 1.048.757 2.487.819 4.113H5.61c.062-1.627.37-3.065.82-4.113.252-.59.537-1.028.823-1.31ZM4.41 7.4c.062-1.76.394-3.366.917-4.586a6.87 6.87 0 0 1 .403-.8A6.405 6.405 0 0 0 1.628 7.4H4.41ZM1.628 8.6H4.41c.062 1.76.394 3.366.917 4.586.122.284.256.553.403.8A6.405 6.405 0 0 1 1.628 8.6Zm3.983 0h4.778c-.062 1.627-.37 3.065-.82 4.113-.252.59-.537 1.028-.823 1.31-.283.28-.535.377-.746.377-.211 0-.463-.097-.746-.377-.286-.282-.571-.72-.824-1.31-.45-1.048-.757-2.486-.819-4.113Zm5.978 0c-.061 1.76-.393 3.366-.916 4.586a6.87 6.87 0 0 1-.403.8A6.405 6.405 0 0 0 14.372 8.6H11.59Zm2.783-1.2a6.405 6.405 0 0 0-4.102-5.386c.147.247.281.516.403.8.523 1.22.855 2.825.916 4.586h2.783Z" clipRule="evenodd" /></g><defs><clipPath id="Globe_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;